import React from "react";
import Unauthorized from "../Components/Unauthorized/Unauthorized";

const UnauthorizedPage = () => {
  return <Unauthorized />;
};

export default UnauthorizedPage;
